import React from "react";
import Button from "@mui/material/Button";

const BigButton = props => (
  <Button
    sx={{
      fontSize: 22,
      display: "flex",
      flexGrow: 1,
      width: "100%",
      height: props.height || 200,
    }}
    {...props}
  />
);

BigButton.defaultProps = {
  color: "primary",
  variant: "contained",
};

export default BigButton;
